// DEPENDENCIES
import React, { useState } from 'react';
import { useSpring, animated, styled } from 'react-spring';
// COMPONENTS

const Overlay = (props) => {

    const animateShow = useSpring({ opacity: 1, from: { opacity: 0 }})
    const overlayDarknessOptions = {
        normal: "normal",
        dark: "dark"
    }

    return (
        <button
            className={`overlay ${props.overlayDarkness ? overlayDarknessOptions[props.overlayDarkness] : "normal"}`}
            style={animateShow}
            onClick={props.onClick ? props.onClick : () => { }}
        />
    );
}

export default Overlay;